"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const Container = styled_1.default("div")(({ theme }) => ({
    ":not(:last-child)": { marginBottom: theme.space.content },
}));
const CardItemTitle = styled_1.default("div")(({ theme }) => ({
    color: theme.color.text.lightest,
    fontFamily: theme.font.family.main,
    fontWeight: theme.font.weight.medium,
    fontSize: theme.font.size.fineprint,
    textTransform: "uppercase",
}));
const CardItemBody = styled_1.default("div")(({ theme, monospace }) => ({
    color: theme.color.text.default,
    fontFamily: monospace ? theme.font.family.code : theme.font.family.main,
    fontSize: theme.font.size.body,
    marginTop: theme.space.base,
}));
const CardItem = (_a) => {
    var { title, value, monospace, children } = _a, props = __rest(_a, ["title", "value", "monospace", "children"]);
    return (React.createElement(Container, Object.assign({}, props),
        React.createElement(CardItemTitle, null, title),
        React.createElement(CardItemBody, { monospace: monospace }, children || value)));
};
exports.default = CardItem;
//# sourceMappingURL=CardItem.js.map